module.exports = __webpack_public_path__ + "img/selected7-min.e8e41027.png";